"use strict";

document.addEventListener('DOMContentLoaded', function () {

    // Fallback for the prototype (DE)
    const splideI18nDefault = {
        prev: 'Vorheriger Slide',
        next: 'Nächster Slide',
        first: 'Erster Slide',
        last: 'Letzter Slide',
        slideX: 'Gehe zu Slide %s',
        pageX: 'Gehe zu Seite %s',
        play: 'Autoplay starten',
        pause: 'Autoplay pausieren',
        carousel: 'Slider',
        slide: 'Slide',
        select: 'Wähle einen Slide zum Anzeigen',
    };

    // Logic for initialization (Merging of defaults and MODX overrides)
    const i18nConfig = Object.assign({}, splideI18nDefault, window.splideL10n || {});



    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide heroSlider
    // *
    // *

    const heroSlider = document.getElementsByClassName('js-hero-slider');

    if (heroSlider !== null) {
        for (let i = 0; i < heroSlider.length; i++) {
            new Splide(heroSlider[i], {
                type: 'fade',
                pauseOnHover: true,
                rewind: true,
                lazyLoad: 'nearby',
                i18n: i18nConfig
            }).mount();
        }
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide textSlider
    // *
    // *

    const textSlider = document.getElementsByClassName('js-text-slider');

    if (textSlider !== null) {
        for (let i = 0; i < textSlider.length; i++) {
            new Splide(textSlider[i], {
                type: 'slide',
                rewind: true,
                arrows: true,
                pagination: true,
                lazyLoad: 'nearby',
                perPage: 1,
                gap: '3rem',
                i18n: i18nConfig,
                breakpoints: {
                    768: {
                        perPage: 1,
                    }
                }
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide locationsSlider (mobile only – destroyed on desktop)
    // *
    // *

    const locationsSliders = document.getElementsByClassName('js-locations-slider');

    if (locationsSliders.length > 0) {
        const locationsItems = document.querySelectorAll('.locations__item');

        function enableDesktopFocus() {
            locationsItems.forEach(function (item) {
                item.setAttribute('tabindex', '0');
                item.setAttribute('role', 'button');
            });
        }

        for (let i = 0; i < locationsSliders.length; i++) {
            const splide = new Splide(locationsSliders[i], {
                type: 'slide',
                rewind: true,
                arrows: false,
                pagination: false,
                perPage: 1,
                mediaQuery: 'min',
                breakpoints: {
                    1024: {
                        destroy: true,
                    }
                },
                i18n: i18nConfig,
            });

            splide.on('destroy', enableDesktopFocus);
            splide.mount();
        }

        // Desktop: click / hover / keyboard activates panel

        if (locationsItems.length > 0) {
            locationsItems.forEach(function (item) {
                function activateItem() {
                    if (window.innerWidth >= 1024) {
                        locationsItems.forEach(function (el) { el.classList.remove('is-active'); });
                        item.classList.add('is-active');
                    }
                }

                item.addEventListener('click', activateItem);
                item.addEventListener('mouseenter', activateItem);

                item.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        activateItem();
                    }
                });
            });
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide actionSlider
    // *
    // *

    const actionSliders = document.querySelectorAll('.actionslider');

    actionSliders.forEach(function (root) {
        const sliderEl = root.querySelector('.js-actionslider');
        if (!sliderEl) return;

        const timelineTrack = root.querySelector('.js-actionslider-timelineTrack');
        const counterEl = root.querySelector('.js-actionslider-counter');
        const prevBtn = root.querySelector('.js-actionslider-prev');
        const nextBtn = root.querySelector('.js-actionslider-next');
        const lion = root.querySelector('.actionslider__lion');
        const mobileIconImg = root.querySelector('.js-actionslider-mobile-icon img');

        // Timeline-Punkte werden aus den tatsächlich vorhandenen Slides erzeugt,
        // damit die Anzahl der Schritte im CMS frei wählbar bleibt (Repeater-Feld).
        let timelineDots = [];

        if (timelineTrack) {
            const items = sliderEl.querySelectorAll('.actionslider__item');

            items.forEach(function (item, i) {
                const itemIconImg = item.querySelector('.actionslider__itemIcon img');

                const dot = document.createElement('div');
                dot.className = 'actionslider__timelineDot' + (i === 0 ? ' is-active' : '');
                dot.setAttribute('aria-hidden', 'true');

                const iconWrap = document.createElement('div');
                iconWrap.className = 'actionslider__timelineIcon';

                if (itemIconImg) {
                    const img = document.createElement('img');
                    img.src = itemIconImg.src;
                    img.alt = '';
                    img.width = 36;
                    img.height = 36;
                    iconWrap.appendChild(img);
                }

                dot.appendChild(iconWrap);
                timelineTrack.appendChild(dot);
            });

            timelineDots = timelineTrack.querySelectorAll('.actionslider__timelineDot');
        }

        const actionSplide = new Splide(sliderEl, {
            type: 'slide',
            rewind: false,
            arrows: false,
            pagination: false,
            focus: 0,
            perPage: 1,
            gap: '4rem',
            padding: 0,
            mediaQuery: 'min',
            breakpoints: {
                1024: {
                    perPage: 2,
                    gap: '2rem',
                    padding: { right: '18%' },
                }
            },
            i18n: i18nConfig,
        }).mount();

        if (prevBtn) prevBtn.addEventListener('click', function () { actionSplide.go('<'); });
        if (nextBtn) nextBtn.addEventListener('click', function () { actionSplide.go('>'); });

        function moveLion(index) {
            if (!lion || !timelineDots[index]) return;
            const dot = timelineDots[index];
            const timeline = root.querySelector('.js-actionslider-timeline');
            if (!timeline) return;
            const timelineRect = timeline.getBoundingClientRect();
            const isMobile = window.innerWidth < 1024;

            // Mobile: nur ein Icon sichtbar (Badge) → Löwe läuft vom Icon-Rand
            // (Abstand = Icon-Breite) bis zum echten Browserrand, dazwischen interpoliert.
            if (isMobile) {
                const firstDot = timelineDots[0];
                const firstDotRect = firstDot.getBoundingClientRect();
                const startX = firstDotRect.right - timelineRect.left + firstDotRect.width + 30;
                const maxLeft = window.innerWidth - timelineRect.left - lion.offsetWidth;
                const progress = index / (timelineDots.length - 1);
                lion.style.left = Math.min(startX + (maxLeft - startX) * progress, maxLeft) + 'px';
                return;
            }

            const maxLeft = timelineRect.width - lion.offsetWidth;
            const gap = 20;
            const dotRightX = dot.getBoundingClientRect().right - timelineRect.left;
            lion.style.left = Math.min(dotRightX + gap, maxLeft) + 'px';
        }

        function updateState(index) {
            const total = actionSplide.length;
            const end = actionSplide.Components.Controller.getEnd();

            if (counterEl) counterEl.textContent = (index + 1) + ' / ' + total;

            if (prevBtn) prevBtn.disabled = index <= 0;
            if (nextBtn) nextBtn.disabled = index >= end;

            timelineDots.forEach(function (dot, i) {
                dot.classList.toggle('is-active', i === index);
            });

            if (mobileIconImg) {
                const activeIconImg = timelineDots[index] && timelineDots[index].querySelector('.actionslider__timelineIcon img');
                if (activeIconImg) mobileIconImg.src = activeIconImg.src;
            }

            moveLion(index);
        }

        let currentActionSlide = 0;

        actionSplide.on('move', function (newIndex) {
            currentActionSlide = newIndex;
            updateState(newIndex);
        });

        // Counter, Dots und Buttons sofort initialisieren — nur die Löwen-Position
        // braucht das load-Event (Maße stehen erst mit geladenen Bildern fest).
        updateState(currentActionSlide);

        // Initialisierung nach dem Mount — Transition kurz deaktivieren, damit der
        // Löwe nicht sichtbar vom CSS-Default zur berechneten Position springt/animiert.
        window.addEventListener('load', function () {
            if (lion) lion.style.transition = 'none';
            updateState(currentActionSlide);
            if (lion) {
                void lion.offsetWidth; // Reflow erzwingen
                requestAnimationFrame(function () {
                    lion.style.transition = '';
                    lion.classList.add('is-positioned');
                });
            }
        });

        // Position neu berechnen, wenn sich die Viewport-Breite ändert
        // (z. B. Wechsel zwischen Desktop-/Mobile-Layout).
        let actionResizeTimeout;
        window.addEventListener('resize', function () {
            clearTimeout(actionResizeTimeout);
            actionResizeTimeout = setTimeout(function () {
                moveLion(currentActionSlide);
            }, 100);
        });
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide testimonialSlider
    // *
    // *

    const testimonialSliderEl = document.querySelector('.js-testimonial-slider');

    if (testimonialSliderEl !== null) {
        const prevBtn = document.querySelector('.js-testimonial-prev');
        const nextBtn = document.querySelector('.js-testimonial-next');
        const statusEl = document.querySelector('.js-testimonial-status');

        const testimonialSplide = new Splide('.js-testimonial-slider', {
            type: 'loop',
            arrows: false,
            pagination: false,
            perPage: 1,
            i18n: i18nConfig,
        }).mount();

        if (prevBtn) prevBtn.addEventListener('click', function () { testimonialSplide.go('<'); });
        if (nextBtn) nextBtn.addEventListener('click', function () { testimonialSplide.go('>'); });

        function updateTestimonialStatus(index) {
            if (!statusEl) return;
            statusEl.textContent = 'Bewertung ' + (index + 1) + ' von ' + testimonialSplide.length;
        }

        testimonialSplide.on('move', function (newIndex) {
            updateTestimonialStatus(newIndex);
        });

        updateTestimonialStatus(testimonialSplide.index);
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollTo
    // *
    // *

    const anchors = document.querySelectorAll(".js-scrollTo");

    for (const anchor of anchors) {
        anchor.addEventListener("click", clickHandler);
    }

    function clickHandler(e) {
        e.preventDefault();

        let href = this.getAttribute("href").split("#");
        let newAnchor = "#my" + href[1]
        let headerOffset = document.querySelector('.header')?.offsetHeight || 0;
        let offsetTop = document.querySelector(newAnchor).offsetTop - headerOffset;

        scroll({
            top: offsetTop,
            behavior: "smooth"
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hash link jump to content
    // * runs on full page load AND on hashchange, since a
    // * link to the current page (only differing by hash)
    // * doesn't always trigger a fresh 'load' event
    // *

    function jumpToHashTarget() {
        let getHash = window.location.hash;
        let elementExists = document.getElementById("my" + getHash.slice(1));

        if (getHash !== null && elementExists !== null) {
            let name = "#my" + getHash.slice(1);
            let headerOffset = document.querySelector('.header')?.offsetHeight || 0;
            let offsetTop = document.querySelector(name).offsetTop - headerOffset;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }

    window.addEventListener('load', jumpToHashTarget, false);
    window.addEventListener('hashchange', jumpToHashTarget, false);



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollToTop
    // *
    // *

    const scrolltotop = document.querySelector(".js-scrolltop");

    if (scrolltotop !== null) {
        // show and hide scrollToTop btn on scroll
        document.addEventListener('scroll', function (e) {
            if (window.scrollY > 300) {
                scrolltotop.classList.add("show");
            } else {
                scrolltotop.classList.remove("show");
            }
        });

        // onclick scroll to top
        scrolltotop.onclick = function (e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }


    }



    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * anchor nav scrollTo
    // *
    // *

    // get browser width
    let browserWidth = window.innerWidth;
    let anchorBox = document.querySelector('.js-anchor-nav');
    let anchorBoxSticky = document.querySelector('.js-anchor-sticky');

    // check if anchor modul is set to sticky
    if (anchorBoxSticky !== null) {
        window.addEventListener('scroll', function (e) {
            // get pos from anchorbox
            let pos = Math.round(anchorBox.getBoundingClientRect().y);

            if (pos <= 0) {
                anchorBox.classList.add("stick");
            } else {
                anchorBox.classList.remove("stick");
            }
        });
    }

    // check if anchor modul is set
    if (anchorBox !== null) {
        // needed for sticky anchor to calculate offsetTop
        anchorBoxHeight = anchorBox.offsetHeight;

        if (browserWidth > 1280) {
            anchorBoxHeight = anchorBoxHeight;
        } else {
            anchorBoxHeight = 0;
        }

        const anchors = document.querySelectorAll(".js-scrollTo");

        for (const anchor of anchors) {
            anchor.addEventListener("click", clickHandler);
        }

        function clickHandler(e) {
            e.preventDefault();

            let href = this.getAttribute("href").split("#");
            let newAnchor = "#my" + href[1]
            let offsetTop = document.querySelector(newAnchor).offsetTop - anchorBoxHeight;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * modal window
    // *
    // *

    let modalWindow = document.querySelector(".js-modal");
    let modalOpen = document.querySelector(".js-modal-btn-open");
    let modalClose = document.querySelector(".js-modal-btn-close");

    /* onclick show modal window */
    if (modalOpen !== null) {
        modalOpen.onclick = function () {
            if (typeof modalWindow.showModal === "function") {
                modalWindow.showModal();
            } else {
                modalWindow.style.display = "block";
            }
            modalClose.focus();
        }
    }

    /* close modal window */
    if (modalClose !== null) {
        modalClose.onclick = function () {
            if (typeof modalWindow.close === "function") {
                modalWindow.close();
            } else {
                modalWindow.style.display = "none";
            }
        }
    }

    /* clicks anywhere outside close modal window */
    window.onclick = function (event) {
        if (event.target == modalWindow) {
            if (typeof modalWindow.close === "function") {
                modalWindow.close();
            } else {
                modalWindow.style.display = "none";
            }
        }
    }




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion: only one item open at a time (per accordion instance)
    // *
    // *

    const title = document.querySelectorAll(".js-accordion-title");

    for (let i = 0; i < title.length; i++) {
        title[i].onclick = function (e) {
            const isOpen = this.classList.contains("open");
            const scope = this.closest(".accordion") || document;

            scope.querySelectorAll(".js-accordion-title.open").forEach(function (btn) {
                btn.classList.remove("open");
                btn.setAttribute('aria-expanded', 'false');
                btn.parentElement.nextElementSibling.classList.remove("open");
            });

            if (!isOpen) {
                this.classList.add("open");
                this.setAttribute('aria-expanded', 'true');
                this.parentElement.nextElementSibling.classList.add("open");
            }
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * open external links in new tab
    // *
    // *

    function externalLinks() {
        for (let links = document.getElementsByTagName("a"), number = 0; number < links.length; number++) {
            let currentLink = links[number];

            // check if link has same hostname. if not add target blank.
            currentLink.getAttribute("href") && currentLink.hostname !== location.hostname && (currentLink.target = "_blank")
        }
    };

    externalLinks();




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * native parallax replacement
    // *
    // *

    const initParallax = () => {
        const parallaxImages = document.querySelectorAll('.js-parallax');
        if (parallaxImages.length === 0) return;

        const observerOptions = {
            threshold: 0,
            rootMargin: "0px"
        };

        const parallaxObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.dataset.visible = "true";
                } else {
                    entry.target.dataset.visible = "false";
                }
            });
        }, observerOptions);

        parallaxImages.forEach(img => {
            parallaxObserver.observe(img);
            // set initial scale to have some buffer for moving
            img.style.transform = "scale(1.2) translateY(0px)";
        });

        const updateParallax = () => {
            parallaxImages.forEach(img => {
                if (img.dataset.visible === "true") {
                    const rect = img.getBoundingClientRect();
                    const windowHeight = window.innerHeight;
                    const elementHeight = rect.height;
                    const elementCenter = rect.top + elementHeight / 2;
                    const viewportCenter = windowHeight / 2;

                    // calculate distance from center of viewport (-1 to 1)
                    const distance = (elementCenter - viewportCenter) / (windowHeight / 2 + elementHeight / 2);
                    const movement = distance * 50; // shift by 50px max

                    img.style.transform = `scale(1.2) translateY(${movement}px)`;
                }
            });
            requestAnimationFrame(updateParallax);
        };

        requestAnimationFrame(updateParallax);
    };

    initParallax();



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * native aos replacement (Intersection Observer)
    // *
    // *

    const aosElements = document.querySelectorAll('[data-aos]');

    const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
    };

    const aosObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('aos-animate');
                if (entry.target.getAttribute('data-aos-once') !== 'false') {
                    observer.unobserve(entry.target);
                }
            } else {
                if (entry.target.getAttribute('data-aos-once') === 'false') {
                    entry.target.classList.remove('aos-animate');
                }
            }
        });
    }, observerOptions);

    aosElements.forEach(element => {
        aosObserver.observe(element);
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * editorial buttons: animate in near viewport center
    // *
    // *

    const inviewElements = document.querySelectorAll('.js-inview');

    const inviewObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-inview');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0,
        rootMargin: "-40% 0px -40% 0px"
    });

    inviewElements.forEach(element => {
        const rect = element.getBoundingClientRect();
        const isAlreadyVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isAlreadyVisible) {
            element.classList.add('is-inview');
        } else {
            inviewObserver.observe(element);
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header: mobile menu toggle
    // *
    // *

    const mobileToggle = document.querySelector('.js-mobile-toggle');
    const mobileClose = document.querySelector('.js-mobile-close');
    const mobileNav = document.querySelector('.header__mobile-nav');
    const headerEl = document.querySelector('.header');

    function openMobileMenu() {
        if (mobileNav === null) return;
        mobileNav.classList.add('is-open');
        mobileNav.setAttribute('aria-hidden', 'false');
        if (headerEl !== null) headerEl.classList.add('is-menu-open');
        if (mobileToggle !== null) mobileToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
        if (mobileNav === null) return;
        mobileNav.classList.remove('is-open');
        mobileNav.setAttribute('aria-hidden', 'true');
        if (headerEl !== null) headerEl.classList.remove('is-menu-open');
        if (mobileToggle !== null) mobileToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }

    if (mobileToggle !== null) {
        mobileToggle.addEventListener('click', openMobileMenu);
    }

    if (mobileClose !== null) {
        mobileClose.addEventListener('click', closeMobileMenu);
    }

    // close mobile menu when an in-page anchor link is clicked
    // (no page reload happens in that case, so the menu would otherwise stay open)
    if (mobileNav !== null) {
        mobileNav.addEventListener('click', function (e) {
            const link = e.target.closest('a[href*="#"]');
            if (!link) return;

            const url = new URL(link.href, window.location.href);
            const samePage = url.pathname === window.location.pathname && url.search === window.location.search;

            if (samePage && url.hash) {
                closeMobileMenu();
            }
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header: desktop dropdown nav
    // *
    // *

    const navDropdownBtns = document.querySelectorAll('.js-nav-dropdown');

    navDropdownBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            const subnav = this.nextElementSibling;
            const isOpen = subnav.classList.contains('is-open');

            // close all open subnavs
            document.querySelectorAll('.header__subnav.is-open').forEach(function (el) {
                el.classList.remove('is-open');
            });
            navDropdownBtns.forEach(function (b) {
                b.setAttribute('aria-expanded', 'false');
            });

            if (!isOpen) {
                subnav.classList.add('is-open');
                this.setAttribute('aria-expanded', 'true');
            }
        });
    });

    // close desktop dropdowns on outside click
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.header__nav-item--has-sub')) {
            document.querySelectorAll('.header__subnav.is-open').forEach(function (el) {
                el.classList.remove('is-open');
            });
            navDropdownBtns.forEach(function (b) {
                b.setAttribute('aria-expanded', 'false');
            });
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header: mobile dropdown nav
    // *
    // *

    const mobileDropdownBtns = document.querySelectorAll('.js-mobile-dropdown');

    mobileDropdownBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            const subnav = this.nextElementSibling;
            const isOpen = subnav.classList.contains('is-open');

            // close all open mobile subnavs
            document.querySelectorAll('.header__mobile-subnav.is-open').forEach(function (el) {
                el.classList.remove('is-open');
            });
            mobileDropdownBtns.forEach(function (b) {
                b.setAttribute('aria-expanded', 'false');
            });

            if (!isOpen) {
                subnav.classList.add('is-open');
                this.setAttribute('aria-expanded', 'true');
            }
        });
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teamList: Zitat-Overlay per Klick/Tap umschalten
    // * (:hover allein reicht auf Touch-Geräten nicht aus)
    // *

    const teamCards = document.querySelectorAll('.js-team-card');

    const toggleTeamCard = (card) => {
        const isActive = card.classList.contains('is-active');

        teamCards.forEach((c) => {
            c.classList.remove('is-active');
            c.setAttribute('aria-expanded', 'false');
        });

        if (!isActive) {
            card.classList.add('is-active');
            card.setAttribute('aria-expanded', 'true');
        }
    };

    teamCards.forEach((card) => {
        card.addEventListener('click', () => toggleTeamCard(card));

        card.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleTeamCard(card);
            }
        });
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * stickyActions: Label per Klick/Tap ausfahren
    // * (:hover allein reicht auf Touch-Geräten nicht aus,
    // * erster Tap zeigt das Label, zweiter Tap folgt dem Link)
    // *

    const stickyActionItems = document.querySelectorAll('.stickyActions__item');

    stickyActionItems.forEach((item) => {
        item.addEventListener('click', function (e) {
            const supportsHover = window.matchMedia('(hover: hover)').matches;
            if (!supportsHover && !item.classList.contains('is-active')) {
                e.preventDefault();

                stickyActionItems.forEach((i) => i.classList.remove('is-active'));
                item.classList.add('is-active');
            }
        });
    });

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.stickyActions__item')) {
            stickyActionItems.forEach((i) => i.classList.remove('is-active'));
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teaserList: Play/Stop-Button für optionale Videos
    // * (kein Autoplay, damit nicht alle Karten gleichzeitig laufen)
    // *

    const teaserVideoToggles = document.querySelectorAll('.js-teaser-video-toggle');

    teaserVideoToggles.forEach((toggle) => {
        const video = toggle.closest('.teaserList__figure')?.querySelector('video');
        if (!video) return;

        toggle.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                toggle.classList.add('is-playing');
                toggle.setAttribute('aria-label', toggle.dataset.labelPause || 'Video anhalten');
            } else {
                video.pause();
                toggle.classList.remove('is-playing');
                toggle.setAttribute('aria-label', toggle.dataset.labelPlay || 'Video abspielen');
            }
        });
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * GLightbox – Bildgalerie
    // *
    // *

    if (document.querySelector('.js-gallery')) {
        GLightbox({
            selector: '.js-gallery',
            touchNavigation: true,
            loop: true,
            keyboardNavigation: true,
            closeOnOutsideClick: true,
        });
    }

});
